module.exports = __webpack_public_path__ + "static/img/pumpipumpe-map.b207af4.png";


//////////////////
// WEBPACK FOOTER
// ./docs/assets/expo/pumpipumpe-map.png
// module id = 947
// module chunks = 2 8